"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
interface ChatMessageProps {
  content: string;
  senderType: "admin" | "visitor";
  createdAt: string;
}
export function ChatMessage(t0) {
  const $ = _c(17);
  const {
    content,
    senderType,
    createdAt
  } = t0;
  const isVisitor = senderType === "visitor";
  let t1;
  if ($[0] !== createdAt) {
    t1 = new Date(createdAt).toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit"
    });
    $[0] = createdAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const time = t1;
  const t2 = isVisitor ? "justify-end" : "justify-start";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("flex", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isVisitor ? "rounded-br-sm bg-accent text-accent-foreground" : "rounded-bl-sm bg-secondary text-secondary-foreground";
  let t5;
  if ($[4] !== t4) {
    t5 = cn("max-w-[75%] rounded-2xl px-3 py-2 text-sm", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== content) {
    t6 = <p className="whitespace-pre-wrap break-words">{content}</p>;
    $[6] = content;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== time) {
    t7 = <p className="mt-1 text-right text-[10px] opacity-60">{time}</p>;
    $[8] = time;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t3 || $[15] !== t8) {
    t9 = <div className={t3}>{t8}</div>;
    $[14] = t3;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}